$(document).ready(() => {
    const $gamesBlock = $('.pair-games');

    for (let i = 0; i < PAIR_GAMES.length; i += 1) {
        let _plannedOn;
        const $gameBlock = $('<div class="mb-3">');

        const $header = $(`<h3>Игра ${i + 1}</h3>`);
        if (PAIR_GAMES[i].can_delete) {
            if (PAIR_GAMES[i].id) {
                const $deleteButton = $(`<button class="btn btn-sm btn-danger ms-3"><i class="fa-solid fa-trash-can"></i></button>`)
                    .on('click', event => {
                        event.preventDefault();

                        const decision = confirm("Точно удалить игру?");
                        if (!decision) {
                            return;
                        }

                        TRNMNT_helpers.disableButtons();
                        $.ajax({
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            type: 'delete',
                            url: DELETE_GAME_URL + '/' + PAIR_GAMES[i].id,
                            contentType: "application/json; charset=utf-8",
                            processData: false,
                            success: response => {
                                TRNMNT_helpers.enableButtons();
                                $gameBlock.remove();
                            },
                            error: TRNMNT_helpers.onErrorAjax,
                            context: TRNMNT_helpers
                        });
                    });
                $header.append($deleteButton);
            }
        }
        $gameBlock.append($header);

        const $block = TRNMNT_helpers.createGameBlock(PAIR_GAMES[i]);
        if (PAIR_GAMES[i].can_edit && !PAIR_GAMES[i].id) {
            const $input = $block.find('.game-planned-on input')
                .on('click', event => event.preventDefault());

            _plannedOn = new tempusdominus.TempusDominus($input[0], {
                display: {
                    calendarWeeks: false,
                    components: {
                        calendar: true,
                        date: true,
                        month: true,
                        year: true,
                        decades: false,
                        clock: true,
                        hours: true,
                        minutes: true,
                        seconds: false,
                    },
                },
            });

            $block.find('.game-planned-on button')
                .on('click', event => {
                    event.preventDefault();

                    const data = {
                        playoff_pair_id: PAIR_GAMES[i].playoff_pair_id,
                        home_id: PAIR_GAMES[i].home.id,
                        away_id: PAIR_GAMES[i].away.id,
                        planned_on: _plannedOn.viewDate.getFullDate(),
                    };

                    $.ajax({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        type: 'post',
                        url: CREATE_GAME_URL,
                        data: JSON.stringify(data),
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        processData: false,
                        success: response => {
                            window.location.reload();
                        },
                        error: TRNMNT_helpers.onErrorAjax,
                        context: TRNMNT_helpers
                    });
                });
        }
        $gameBlock.append($block);

        $gamesBlock.append($gameBlock);
    }
});
